// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__16tql","list":"BalanceDue_list__Byu2O","listRow":"BalanceDue_listRow__J4su4","total":"BalanceDue_total__3Vf7W"};